/* eslint-disable import/no-named-as-default */
import { NavLink, Route, Switch, Redirect } from "react-router-dom";

import PropTypes from "prop-types";
import React from "react";
import { hot } from "react-hot-loader";

import HomePage from "./containers/HomePage";
import AboutPage from "./containers/AboutPage";
import ProjectPage from "./containers/ProjectPage";
import ContactPage from "./containers/ContactPage";

class App extends React.Component {
  render() {
    var currentLocation = window.location.pathname === '/' ? '-home' : window.location.pathname.replace('/', '-');
    const now = new Date;
    const year = now.getYear() + 1900;
    return (
      <div className={'appcontainer page' + currentLocation}>
        <ul className="nav">
          <li><NavLink className="button button-clear title" exact to="/" activeClassName="current">David Coe</NavLink></li>
          <li><NavLink className="button button-clear" to="/history" activeClassName="current">Work History</NavLink></li>
          <li><NavLink className="button button-clear" to="/projects" activeClassName="current">Projects</NavLink></li>
          <li><NavLink className="button button-clear" to="/contact" activeClassName="current">Contact</NavLink></li>
          <li className="right"><a className="button button-clear" href="https://uk.linkedin.com/in/davecoe/">LinkedIn</a></li>
        </ul>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/history" component={AboutPage} />
          <Route exact path="/projects" component={ProjectPage} />
          <Route exact path="/contact" component={ContactPage} />
          <Redirect to="/" />
        </Switch>
        <footer>
          ©{year} David Coe
        </footer>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default hot(module)(App);
